export default "__VITE_ASSET__f5cea930__"